import React, { useState, useEffect } from "react";
import {
  FormGroup,
  Button,
  Row,
  Col,
  FormInput,
  DatePicker,
} from "shards-react";
import { Link } from "react-router-dom";
import baseUrl from "config/baseUrl";
import ReactPaginate from "react-paginate";
import dayjs from "dayjs";
import "dayjs/locale/es";
import useToken from "shared/hook/useToken";
import Layout from "shared/container/LayoutAdmin";
import {
  SelectIndicatorsDataset,
  SelectIndicatorsAgencySetting,
} from "shared/components";
import agencyType from "shared/utils/agencyType";
import styled from "styled-components";
import {
  ModalEmailDetail,
  ModalCreateEmail,
} from "views/AdminEmail/components";

const axios = require("axios").default;

const StyledStatus = styled.div`
  background-color: ${(props) => (props.bg ? props.bg : "#A3A3A3")};
  padding: 5px 15px;
  border-radius: 6px;
  text-align: center;
  color: #fff;
  display: initial;
`;
const StyledButton = styled.a``;

const AdminEmail = (props) => {
  const { token } = useToken();
  const [indicatorsDatasetId, setIndicatorsDatasetId] = useState("");
  const [indicatorsAgencySettingId, setIndicatorsAgencySettingId] = useState(
    ""
  );
  const [agencyTypeData, setAgencyTypeData] = useState(agencyType);
  const [dataAdminEmail, setDataAdminEmail] = useState(null);
  const [selectEmail, setSelectEmail] = useState(null);
  const [openModalEmailDetail, setOpenModalEmailDetail] = useState(false);
  const [openModalCreateEmail, setOpenModalCreateEmail] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [date, setDate] = useState(1);

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          emailNotiId: "",
          indicatorsDatasetSettingId: indicatorsDatasetId,
          indicatorsAgencySettingId: indicatorsAgencySettingId,
        },
        show: 30,
        page: pageNumber,
        orderBy: "emailNotiId",
        orderType: "desc",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/emailnotilist`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDataAdminEmail(response.data);
          setTotalPage(response.data.totalPage);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [
    pageNumber,
    openModalEmailDetail,
    indicatorsDatasetId,
    indicatorsAgencySettingId,
    openModalCreateEmail,
  ]);

  const nextPage = (page, total_page) => {
    setPageNumber(page + 1);
    setTotalPage(total_page);
  };
  const getAgencyTypeName = (agencyTypeId) => {
    const list = agencyTypeData.filter(
      (item) => item.agencyTypeId === agencyTypeId
    );
    if (list.length > 0) {
      return list[0].agencyTypeName;
    } else {
      return "-";
    }
  };
  const getStatus = (status) => {
    switch (status) {
      case 1:
        return <StyledStatus bg="#7FBC46">เปิด</StyledStatus>;
      default:
        return <StyledStatus bg="#A3A3A3">ปิด</StyledStatus>;
    }
  };
  return (
    <>
      <Layout>
        <Row>
          <Col md="12">
            <h6 className="bold" style={{ marginBottom: "30px" }}>
              การแจ้งเตือน E-mail
            </h6>
          </Col>
        </Row>
        <Row>
          <Col md="3">
            <FormGroup>
              <label>หน่วยงานเจ้าของข้อมูล</label>
              <SelectIndicatorsAgencySetting
                placeholder="เลือก"
                name="indicatorsAgencySettingId"
                // disabled
                onChange={(e) => {
                  setIndicatorsAgencySettingId(
                    e.target.value === "0" ? "" : e.target.value
                  );
                }}
                defaultValue={indicatorsAgencySettingId}
                value={indicatorsAgencySettingId}
              />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <label>ข้อมูล/ตัวชี้วัด</label>
              <SelectIndicatorsDataset
                placeholder="เลือก"
                name="indicatorsDatasetSettingId"
                // disabled
                onChange={(e) => {
                  setIndicatorsDatasetId(
                    e.target.value === "0" ? "" : e.target.value
                  );
                }}
                defaultValue={indicatorsDatasetId}
                value={indicatorsDatasetId}
              />
            </FormGroup>
          </Col>
        </Row>
        <hr></hr>
        <Row>
          <Col md="6">
            <h6 className="bold" style={{ marginBottom: "30px" }}>
              ตารางรายการแจ้งเตือน E-mail
            </h6>
          </Col>
          <Col md="6">
            <Button
              className="btn btn-success pull-right"
              style={{ marginBottom: "10px" }}
              type="button"
              onClick={() => setOpenModalCreateEmail(true)}
            >
              + เพิ่มการแจ้งเตือน E-mail
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <div
              className="table-responsive"
              style={{ height: "calc(100vh - 215px)" }}
            >
              <table className="table mb-0">
                <thead className="thead-dark table-middle">
                  <tr>
                    <th scope="col" style={{ minWidth: "400px" }}>
                      รายการข้อมูล/ตัวชี้วัด
                    </th>
                    <th scope="col" style={{ minWidth: "300px" }}>
                      หน่วยงานเจ้าของข้อมูล
                    </th>
                    <th scope="col" style={{ minWidth: "150px" }}>
                      การนำเข้าข้อมูล
                    </th>
                    <th scope="col" style={{ minWidth: "350px" }}>
                      ประเภทผู้ใช้งานที่ได้รับการแจ้งเตือน
                    </th>
                    <th scope="col" style={{ minWidth: "150px" }}>
                      สถานะแจ้งเตือน
                    </th>
                    <th scope="col" style={{ minWidth: "100px" }}>
                      เครื่องมือ
                    </th>
                  </tr>
                </thead>
                <tbody className="table-middle">
                  {dataAdminEmail != null && dataAdminEmail.data.length > 0 ? (
                    dataAdminEmail.data.map((item, key) => (
                      <tr key={key}>
                        <td>{item.indicatorsDatasetSettingName}</td>
                        <td>{item.indicatorsAgencySettingName}</td>
                        <td>{item.importName}</td>
                        <td>{item.emailTypeUserName || "-"}</td>
                        <td className="text-center">
                          {getStatus(item.notiEnable)}
                        </td>
                        <td className="text-center">
                          <StyledButton
                            className="btn-link"
                            onClick={() => {
                              setSelectEmail(item.emailNotiId);
                              setOpenModalEmailDetail(true);
                            }}
                            role="button"
                          >
                            แก้ไข
                          </StyledButton>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>ยังไม่มีรายการการแจ้งเตือน E-mail</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Col>
          <Col md="12" style={{ textAlign: "right" }}>
            {dataAdminEmail != null && (
              <ReactPaginate
                pageCount={totalPage}
                forcePage={pageNumber - 1}
                containerClassName="pagination"
                nextLabel=">"
                previousLabel="<"
                onPageChange={({ selected }) => {
                  nextPage(selected, totalPage);
                }}
              />
            )}
          </Col>
        </Row>
      </Layout>

      {openModalEmailDetail && (
        <ModalEmailDetail
          open={openModalEmailDetail}
          toggle={() => setOpenModalEmailDetail(false)}
          selectEmail={selectEmail}
        />
      )}

      {openModalCreateEmail && (
        <ModalCreateEmail
          open={openModalCreateEmail}
          toggle={() => setOpenModalCreateEmail(false)}
        />
      )}
    </>
  );
};

export default AdminEmail;
